import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function User({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <User.Outline {...props} /> : <User.Solid {...props} />;
}

User.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 11.7017 3.6 C 9.353 3.6 7.4486 5.5042 7.4481 7.8534 C 7.4402 10.1954 9.3318 12.1004 11.6747 12.1088 L 11.6769 12.1088 H 11.7017 C 14.0514 12.1088 15.9561 10.2042 15.9561 7.8544 C 15.9561 5.5046 14.0514 3.6 11.7017 3.6 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.127 14.4563C10.1891 14.4563 8.30564 14.6 6.8836 15.0767C6.16878 15.3163 5.51484 15.658 5.03289 16.1583C4.53315 16.6771 4.25 17.3353 4.25 18.1153C4.25 18.8937 4.53071 19.5523 5.02764 20.073C5.50728 20.5756 6.15895 20.9206 6.87311 21.1634C8.29357 21.6463 10.1779 21.7953 12.127 21.7953C14.0654 21.7953 15.9489 21.6514 17.3709 21.1745C18.0856 20.9348 18.7394 20.5931 19.2213 20.0928C19.7209 19.5742 20.004 18.916 20.004 18.1363C20.004 17.3581 19.7233 16.6997 19.2265 16.179C18.747 15.6765 18.0954 15.3315 17.3813 15.0886C15.961 14.6056 14.0767 14.4563 12.127 14.4563Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

User.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1271 2C9.19122 2 6.81081 4.38017 6.81009 7.31666C6.80033 10.2443 9.16466 12.6255 12.0934 12.636L12.0961 12.636H12.1271C15.0643 12.636 17.4451 10.2552 17.4451 7.318C17.4451 4.38079 15.0643 2 12.1271 2Z"
          fill="currentColor"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.127 14.4563C10.1891 14.4563 8.30564 14.6 6.8836 15.0767C6.16878 15.3163 5.51484 15.658 5.03289 16.1583C4.53315 16.6771 4.25 17.3353 4.25 18.1153C4.25 18.8937 4.53071 19.5523 5.02764 20.073C5.50728 20.5756 6.15895 20.9206 6.87311 21.1634C8.29357 21.6463 10.1779 21.7953 12.127 21.7953C14.0654 21.7953 15.9489 21.6514 17.3709 21.1745C18.0856 20.9348 18.7394 20.5931 19.2213 20.0928C19.7209 19.5742 20.004 18.916 20.004 18.1363C20.004 17.3581 19.7233 16.6997 19.2265 16.179C18.747 15.6765 18.0954 15.3315 17.3813 15.0886C15.961 14.6056 14.0767 14.4563 12.127 14.4563Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
